<template>
  <div>
    <van-search
      autocomplete="off"
      v-model="queryParams.name"
      @search="onSubmit"
      placeholder="请输入品牌名称进行查询"
    >
      <template #right-icon>
        <van-icon name="filter-o" @click="openFilter" />
      </template>
    </van-search>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已显示全部"
      ref="scrollContainer"
      @load="getList(true)"
    >
      <div v-for="item in tableData" :key="item.id" class="container">
        <div class="available">
          <div class="">
            <div
              :class="[
                {
                  color1: item.available,
                  color2: !item.available,
                },
                'status',
              ]"
            >
              {{ item.available ? "启用" : "停用" }}
            </div>
          </div>
        </div>
        <div class="content">
          <div class="left">
            <div class="item flex">
              <div class="label">品牌名称:</div>
              <div class="value">{{ item.name }}</div>
            </div>
            <div class="item flex">
              <div class="label">品牌编号:</div>
              <div class="value">{{ item.code }}</div>
            </div>
            <div class="item flex">
              <div class="label">备注:</div>
              <div class="value">{{ item.description || "-" }}</div>
            </div>
          </div>
          <div class="actions">
            <div @click="handleView(item)">查看</div>
            <div @click="handleEdit(item)">修改</div>
          </div>
        </div>
      </div>
    </van-list>

    <!-- 筛选弹窗 -->
    <van-popup
      v-model:show="filterVisible"
      position="top"
      :style="{ height: '40%' }"
    >
      <div class="filter-content">
        <div class="filter-title">筛选条件</div>
        <div class="filter-item">
          <div class="filter-label">状态</div>
          <div class="filter-options">
            <span
              v-for="option in statusOptions"
              :key="option.value"
              :class="{ active: queryParams.available === option.value }"
              @click="selectStatus(option.value)"
            >
              {{ option.label }}
            </span>
          </div>
        </div>
        <div class="filter-actions">
          <van-button size="small" @click="resetFilter">重置</van-button>
          <van-button size="small" type="primary" @click="confirmFilter">
            确定
          </van-button>
        </div>
      </div>
    </van-popup>
    <!-- 底部新增按钮 -->
    <div class="bottom-add-btn">
      <van-button type="primary" block @click="handleAdd">
        新增品牌
      </van-button>
    </div>
  </div>
</template>

<script>
import {
  query,
  downloadImportTemplate,
} from "@/service/api/basedata/product/brand";
import UploadImage from "@/components/uploadImage";

export default {
  name: "ProductBrand",
  components: {
    UploadImage,
  },
  data() {
    return {
      loading: false,
      finished: false,
      tableData: [],
      totalCount: 0,
      pageIndex: 1,
      pageSize: 20,
      totalPage: 1,
      queryParams: {
        name: "",
        available: true,
      },
      filterVisible: false,
      statusOptions: [
        { label: "全部", value: null },
        { label: "启用", value: true },
        { label: "停用", value: false },
      ],
      importDialogVisible: false,
    };
  },
  mounted() {
    this.onSubmit();
    setInterval(() => {}, 4000);
  },
  methods: {
    openFilter() {
      this.filterVisible = true;
    },
    selectStatus(value) {
      this.queryParams.available = value;
    },
    resetFilter() {
      this.queryParams.name = "";
      this.queryParams.available = true;
    },
    confirmFilter() {
      this.filterVisible = false;
      this.onSubmit();
    },
    onSubmit() {
      this.pageIndex = 1;
      this.tableData = [];
      this.finished = false;
      this.getList();
    },
    getList(load) {
      if (load) {
        this.pageIndex++;
      }
      this.loading = true;
      const params = {
        ...this.queryParams,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      query(params)
        .then((res) => {
          this.loading = false;
          if (res.code === 200) {
            if (load) {
              this.tableData = this.tableData.concat(res.data.datas || []);
            } else {
              this.tableData = res.data.datas || [];
            }
            this.totalCount = res.data.totalCount || 0;
            this.totalPage = res.data.totalPage || 1;
            if (this.pageIndex >= this.totalPage) {
              this.finished = true;
            }
          }
        })
        .catch(() => {
          this.loading = false;
          this.finished = true;
        });
    },
    handleAdd() {
      this.$router.push("/product/brandDetail/add");
    },
    handleView(row) {
      this.$router.push(`/product/brandDetail/${row.id}/view`);
    },
    handleEdit(row) {
      this.$router.push(`/product/brandDetail/${row.id}/edit`);
    },
    handleDownloadTemplate() {
      downloadImportTemplate().then((res) => {
        const blob = new Blob([res], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "商品品牌导入模板.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      });
    },
    beforeUpload(file) {
      const isExcel =
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";
      if (!isExcel) {
        this.$toast.fail("只能上传Excel文件");
        return false;
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$toast.fail("上传文件大小不能超过10MB");
        return false;
      }
      return true;
    },
    handleUploadSuccess(res) {
      if (res.code === 200) {
        this.$toast.success("导入成功");
        this.importDialogVisible = false;
        this.onSubmit();
      } else {
        this.$toast.fail(res.msg || "导入失败");
      }
    },
  },
};
</script>

<style lang="less" scoped>
* {
  touch-action: pan-y;
}
.van-cell {
  padding: 5px 2px 2px 5px !important;
}
.top-actions {
  padding: 5px 10px;
  display: flex;
  gap: 10px;
  background-color: #fff;
}
.container {
  margin-top: 5px;
  padding: 10px 0 10px 10px;
  background-color: #fff;
  position: relative;
  .available {
    position: absolute;
    right: 0;
    font-size: 15px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .status {
      width: 5rem;
      height: 26px;
      line-height: 26px;
      text-align: center;
      flex: 2;
      margin-left: 20px;
      border-radius: 13px 0 0 13px;
      color: #fff;
      overflow: hidden;
      font-size: 14px;
    }

    .color1 {
      background: linear-gradient(83deg, #07c160, #98bf8c);
    }

    .color2 {
      background: linear-gradient(83deg, red, #bfa98c);
    }
  }
  .content {
    margin-top: 10px;
    font-size: 14px;
    padding: 0;

    .left {
      display: flex;
      flex-wrap: wrap;
      gap: 0.3rem;
      flex-direction: column;
      justify-content: flex-start;

      .item {
        width: 14rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 0;
        margin-right: 0.45rem;
        font-size: 14px;

        .label {
          color: #333;
          min-width: 4rem;
        }

        .value {
          font-size: 12px;
          color: #999;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
        }
      }
    }

    .actions {
      margin-top: 8px;
      display: flex;
      gap: 8px;
      padding-right: 10px;
      justify-content: space-evenly;
      border-top: 1px solid #f4f4f4;
      padding-top: 5px;
      div{
        color: #409eff;
      }
    }
  }
}

.filter-content {
  padding: 15px;
  .filter-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;
  }
  .filter-item {
    margin-bottom: 15px;
    .filter-label {
      font-size: 14px;
      margin-bottom: 8px;
      color: #333;
    }
    .filter-options {
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
      span {
        padding: 4px 12px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        font-size: 14px;
        cursor: pointer;
        &.active {
          background-color: #1989fa;
          color: #fff;
          border-color: #1989fa;
        }
      }
    }
  }
  .filter-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
  }
}

.dialog-content {
  padding: 15px;
  .dialog-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;
    text-align: center;
  }
  .dialog-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 15px;
  }
  .import-tip {
    padding: 10px 0;
    text-align: center;
    a {
      color: #1989fa;
    }
  }
}

.bottom-add-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 15px;
  background-color: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
}

::v-deep .van-list {
  height: calc(100vh - 9rem);
  overflow: auto;
  padding-bottom: 60px;
}
</style>
